export default __webpack_public_path__ + "static/media/Ficha Técnica - Purê de Manga Asséptica Concentrada. BRIX 14-16 VARIEDADE TOMMY.0b175d9a.pdf";